import { render, staticRenderFns } from "./AddCustomerMerchantAgent.vue?vue&type=template&id=019ed93e"
import script from "./AddCustomerMerchantAgent.vue?vue&type=script&lang=js"
export * from "./AddCustomerMerchantAgent.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerMerchantAgent.vue?vue&type=style&index=0&id=019ed93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports